/** Why a contact may (or may not) sign in to its company's client portal. */
export type PortalAccessReason =
  | "no_company"
  | "only_contact"
  | "primary_contact"
  | "billing_contact"
  | "invoice_recipient"
  | "granted"
  | "not_granted";

/**
 * One portal per company. Everyone the company works through gets in on
 * their own: no company, only contact, primary contact, a billing contact,
 * or someone invoices were sent to. Other people of a multi-contact company
 * need staff to turn on `portal_access`.
 */
export const resolvePortalAccessReason = (params: {
  hasCompany: boolean;
  isPrimaryContact: boolean;
  companyContactCount: number;
  isBillingContact?: boolean;
  isInvoiceRecipient?: boolean;
  portalAccess: boolean;
}): PortalAccessReason => {
  if (!params.hasCompany) return "no_company";
  if (params.companyContactCount <= 1) return "only_contact";
  if (params.isPrimaryContact) return "primary_contact";
  if (params.isBillingContact) return "billing_contact";
  if (params.isInvoiceRecipient) return "invoice_recipient";
  return params.portalAccess ? "granted" : "not_granted";
};

export const portalAccessAllowed = (reason: PortalAccessReason) =>
  reason !== "not_granted";
